export const nodeSize = 0.005;
export const edgeSpacing = 0.0012;
export const initalZoom = 0.85;
export const edgeIntersectionTolerance = 0.0;
export const arrowHeadRelativePosition = [0.003, 0.015];
export const labelOffset = 0.01;
export const fontSize = 10;
export const lineWidth = 1;
export const zoomScroll = (old: number, delta: number) => (old ** (1 / 6) - delta / 2000) ** 6;
